import 'rxjs/add/operator/do';
import 'rxjs/add/operator/timeout';

import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs/Observable';

import { environment } from '../../environments/environment';
import { StartupService } from './startup.service';

@Injectable()
export class BrandEnvironmentInterceptor implements HttpInterceptor {

  constructor(private injector: Injector) { }
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // due to known bug Injecting Http dependant service cannot be made in constructor
    const startupService = this.injector.get(StartupService);
    const clonedRequest = req.clone({ headers: req.headers.set('brand-env', `${startupService.websiteName}-${environment.name}`) });

    if (window.navigator.onLine === false) {
      startupService.setErrorModal(true);
    }

    // .timeout(15000)
    return next.handle(clonedRequest).do(event => { }, err => { // timeout of  http request
      startupService.setErrorModal(true);
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/services/brand-environment.interceptor.ts